<template>

   <div class="plr16 mt20 mb20">
   
   
      <div class="f-between form-title ">

          <div  class="f-between"> 
            <a-input  class="filteritem" v-model:value="poi" placeholder="地点名字" />

            <a-input class="filteritem" v-model:value="plate_numer" placeholder="车牌号码" />

            <a-input class="filteritem" v-model:value="car_band" placeholder="品牌" />


            <a-select
              class="filteritem"
              ref="select"
              v-model:value="state"
              style="width: 120px"
              @focus="focus"
              @change="handleChange"
            >
              <a-select-option value="">全&nbsp;&nbsp;&nbsp;&nbsp;部</a-select-option>
              <a-select-option value="待处理">待处理</a-select-option>
              <a-select-option value="已确认">已确认</a-select-option>
              <a-select-option value="不合格">不合格</a-select-option>
            </a-select>
    

            <a-button class="filteritem col-theme"  @click="search_filter()"><search-outlined />查询</a-button>
            <a-button class="filteritem col-theme"  @click="clear_filter"><delete-outlined />清空条件</a-button>
          
          </div>


          <a-pagination v-model:current="pagenum" :total="infoCount" show-size-changer @change="change" :defaultPageSize="pagesize" show-less-items />

      </div>

        
      <div class="listBox">
        <a-list item-layout="horizontal" :data-source="infoList">
          <template #renderItem="{ item }">
            <a-list-item @click="clickitem(item.info_id, item.files)">
                <a-list-item-meta
                 
                >
                <template #title>
                  <span v-if="item.info_id==selected" class="info info_id_selected">{{ item.info_id }} #</span>
                  <span v-if="item.info_id!=selected" class="info info_id">{{ item.info_id }} #</span>

                  <span class="info poi">{{ item.poi }}</span>

                  <span class="info plate_green" v-if="item.license_plate_color =='绿牌'" >{{ item.license_plate_number }}</span>
                  <span class="info plate_yellow" v-if="item.license_plate_color =='黄牌'" >{{ item.license_plate_number }}</span>
                  <span class="info plate_blue" v-if="item.license_plate_color =='蓝牌'" >{{ item.license_plate_number }}</span>
                  <span class="info plate_white" v-if="item.license_plate_color =='白牌'" >{{ item.license_plate_number }}</span>
                  <span class="info plate_black" v-if="item.license_plate_color =='黑牌'" >{{ item.license_plate_number }}</span>

                  <span class="info plate" v-if="item.license_plate_color.indexOf('牌') == -1 && item.license_plate_color != ''" >{{ item.license_plate_number }}</span>
                  
                  <span class="info band">{{ item.car_band }}</span>

                  <span class="info state_g" v-if="item.state.indexOf('已确认') >= 0">{{ item.state }}</span>
                  <span class="info state_r" v-if="item.state.indexOf('不合格') >= 0">{{ item.state }}</span>
                  <span class="info state_y" v-if="item.state.indexOf('待处理') >= 0">{{ item.state }}</span>

                  <span class="info state" v-if="item.state.indexOf('已确认') == -1"  ><a-button class="col-theme"  @click="updateInfo(item.info_id)"><sync-outlined />重新处理</a-button></span>

                  
                 
                </template>


                <template #description>
                <span class="info addr">{{ item.addr }}</span>
                <span class="info create_time">采录IP：{{ item.createip }}</span>
                <span class="info create_time">采录时间：{{ item.create_time }}</span>
                <span class="info create_time">审核时间：{{ item.audit_time }}</span>
                <span class="info create_time">用户ID：{{ item.user_id }}</span>
                
                <span class="info ">车辆颜色：{{ item.car_color }}</span>
                <span class="info ">类型：{{ item.car_type }}</span>
              
                <span class="info ">车牌颜色：{{ item.license_plate_color }}</span>
                <span class="info ">录入次数：{{ item.hit }}</span>
                <span class="info ">备注：{{ item.note }}</span>
                
                
              

                </template>


               
               
              </a-list-item-meta>
            </a-list-item>
          </template>
        </a-list>
        <div class="listBox-img">
          <img :src="photo" width="500"/>
        </div>
            
      </div>


   </div>
 </template>



<script>

  import { mapActions } from "vuex"
  import { message } from 'ant-design-vue'
  import config from "@/common/config"

  export default {


    name: "info",
    data() {
      return {
        car_band: "",
        plate_numer: "",
        poi: "",
        state : "",
        selected:null,
        pagenum:1,
        photo:"",
        pagesize:10,
        infoList:[],
        infoCount:0

      }
    },
    created() {
      this.name = localStorage.getItem('name') || '-'
      this.get_info_list()


    }, 
   
    methods: {
      ...mapActions([
          'info_list',
          'info_update'
        ]),

      change(page, pageSize){
        this.pagenum = page
        this.pagesize = pageSize
        this.get_info_list()
      },

      clickitem(id, files){
        
        let flist = JSON.parse(files)

        this.photo = config.BASE_URL + '/files/' + flist[0]
        this.selected = id

      },
      clear_filter(){
          this.car_band = ''
          this.plate_numer = ''
          this.poi = ''
          this.state = ''

      }, 
      search_filter(){
        this.pagenum = 1
        this.get_info_list()
      },
      get_info_list(){
        this.photo = ''
        let token = localStorage.getItem('t') || 'xx'
        let params = {}
        
        params.token = token
        params.pagenum = this.pagenum
        params.pagesize = this.pagesize

        params.car_band = this.car_band
        params.plate_numer = this.plate_numer
        params.poi = this.poi
        params.state = this.state
        

        this.info_list(params)
          .then((dt) => {
            this.infoList = dt.data
            this.infoCount = dt.count
            
            
          })
          .catch((dt) => {
            this.$router.replace({
                name: 'login'
              })
            
          });


      },
      updateInfo(info_id){

        if(confirm("是否重新发起识别处理任务？") == false){
          return
        }

        let token = localStorage.getItem('t') || 'xx'
        let params = {}
        
        params.token = token
        params.info_id = info_id

        this.info_update(params)
          .then((dt) => {
            this.get_info_list()
            
            
          })
          .catch((dt) => {
            
           this.$router.replace({
                name: 'login'
              })
            
          });

      }

    }


  };

 




</script>

<style scoped>
.filteritem{

margin-right: 20px;
}

.item{

  height:40px;
  line-height:40px;
}

.width50{

 width:50%
}
.devicename{
  width:60%;
  text-overflow: ellipsis; 
  overflow:hidden; 
  white-space: nowrap;
}
.announce{
  cursor: pointer;
  color: yellow;
}
.listBox {
  display: flex;
}
.ant-list {
  flex: 1;
  margin-right: 20px;
}
.listBox-img {
  width: 500px;
}

.info{
  margin: 0 10px;
}

.band{
  font-weight: 600;
}

.state_g{
  color: green;
}

.state_y{
  color: rgb(138, 138, 27);
}

.state_r{
  color: red;
}

.plate_green{
  padding: 2px 8px;
  background: linear-gradient(white, #2cbd2c);
  color: black;
  border: solid 2px #c7c7c7;
}

.plate_blue{
  padding: 2px 8px;
  background-color: #4444e7;
  color: white;
  border: solid 2px #c7c7c7;
}

.plate_yellow{
  padding: 2px 8px;
  background-color: #ffb75e;
  color: black;
  border: solid 2px #6d6d6d;
}

.plate_white{
  padding: 2px 8px;
  background-color: white;
  color: black;
  border: solid 2px #ab0303;
}

.plate_black{
  padding: 2px 8px;
  background-color: black;
  color: white;
  border: solid 2px #c7c7c7;
}

.plate{
  padding: 2px 8px;
  background-color: #999999;
  color: black;
  border: solid 2px #c7c7c7;
}

.info_id_selected{
  color:chocolate;
}
</style>
